// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".App_Button__agX9A{padding:16px;margin-left:-16px;box-shadow:none}@media(min-width: 768px){.App_Button__agX9A{padding:24px}}.App_Button__agX9A:hover{box-shadow:none}.App_Button__agX9A:focus{outline:1px solid #000;box-shadow:none}.App_lockscroll__35bnO{overflow:hidden;height:100%}.App_lockscroll__35bnO>body{overflow:hidden;height:100%}", "",{"version":3,"sources":["webpack://./App.module.scss","webpack://./../node_modules/@trr/common-component-library/lib/Styles/mixins/breakpoints.scss"],"names":[],"mappings":"AAKA,mBACE,YAHe,CAIf,iBAAA,CACA,eAAA,CCSA,yBDZF,mBAMI,YAAA,CAAA,CAGF,yBACE,eAAA,CAGF,yBACE,sBAAA,CACA,eAAA,CAIJ,uBACE,eAAA,CACA,WAAA,CAGF,4BACE,eAAA,CACA,WAAA","sourcesContent":["@import '@trr/common-component-library/lib/Styles/index.scss';\r\n@import './variables.scss';\r\n\r\n$button-padding: 16px;\r\n\r\n.Button {\r\n  padding: $button-padding;\r\n  margin-left: -$button-padding;\r\n  box-shadow: none;\r\n\r\n  @include md {\r\n    padding: 24px;\r\n  }\r\n\r\n  &:hover {\r\n    box-shadow: none;\r\n  }\r\n\r\n  &:focus {\r\n    outline: 1px solid black;\r\n    box-shadow: none;\r\n  }\r\n}\r\n\r\n.lockscroll {\r\n  overflow: hidden;\r\n  height: 100%;\r\n}\r\n\r\n.lockscroll > body {\r\n  overflow: hidden;\r\n  height: 100%;\r\n}\r\n","@import '../variables/breakpoints.scss';\n// Extra Small devices\n@mixin xs {\n  @media (min-width: #{$screen-xs-min}) {\n    @content;\n  }\n}\n\n// Small devices\n@mixin sm {\n  @media (min-width: #{$screen-sm-min}) {\n    @content;\n  }\n}\n\n// Medium devices\n@mixin md {\n  @media (min-width: #{$screen-md-min}) {\n    @content;\n  }\n}\n\n// Medium devices landscape\n@mixin mdl {\n  @media (min-width: #{$screen-mdl-min}) {\n    @content;\n  }\n}\n\n// Large devices\n@mixin lg {\n  @media (min-width: #{$screen-lg-min}) {\n    @content;\n  }\n}\n\n// Extra large devices\n@mixin xl {\n  @media (min-width: #{$screen-xl-min}) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"purpleDark": "#392b64",
	"purple100": "#4c3e7a",
	"purple80": "#716595",
	"purple60": "#948baf",
	"purple40": "#b8b2ca",
	"purple20": "#dbd8e4",
	"purple10": "#edebf1",
	"green100": "#007069",
	"green80": "#44aba3",
	"green60": "#73c0ba",
	"green40": "#a2d5d1",
	"green20": "#d0eae8",
	"green10": "#e7f4f3",
	"yellow100": "#f3d500",
	"yellow80": "#f5de33",
	"yellow60": "#f8e666",
	"yellow40": "#faee99",
	"yellow20": "#fdf7cc",
	"yellow10": "#fdfae5",
	"blue100": "#2546c0",
	"blue80": "#516bcd",
	"blue60": "#7c90d9",
	"blue40": "#a8b5e6",
	"blue20": "#d3daf2",
	"blue10": "#e9ecf8",
	"orange100": "#fa8554",
	"orange80": "#fb9d76",
	"orange60": "#fcb698",
	"orange40": "#fdcebb",
	"orange20": "#fee7dd",
	"orange10": "#fef2ed",
	"rose100": "#ea1845",
	"rose80": "#ee466a",
	"rose60": "#f2748f",
	"rose40": "#f7a3b5",
	"rose20": "#fbd1da",
	"rose10": "#fce7ec",
	"petrol100": "#0b605c",
	"petrol80": "#3c807d",
	"petrol60": "#6da09d",
	"petrol40": "#9dbfbe",
	"petrol20": "#cedfde",
	"petrol10": "#e6efee",
	"gray0": "#707070",
	"gray1": "#7c7d82",
	"gray2": "#a2a4aa",
	"gray3": "#cbcdd2",
	"gray4": "#dde0e7",
	"gray5": "#eff0f9",
	"gray6": "#f5f6fb",
	"white": "#fff",
	"black": "#000",
	"gray": "#707070",
	"textColor": "#404040",
	"disabledColor": "#dde0e7",
	"letterSpacingHeading": "-0.3px",
	"Button": "App_Button__agX9A",
	"lockscroll": "App_lockscroll__35bnO"
};
export default ___CSS_LOADER_EXPORT___;
